import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').constant('UNDERLYING_DEAL_SOURCE', {
        PRIMARY_DEAL_ID: 'PRIMARY_DEAL_ID',
        SECONDARY_TRADE_ID: 'SECONDARY_TRADE_ID',
        EXTERNAL_DEAL: 'EXTERNAL_DEAL',
        MANUAL_INPUT: 'MANUAL_INPUT'
    });
})();
